import { mapKeys } from 'lodash-es'

export const CUSTOM = 'CUSTOM'
export const MENU_TYPE = 'MENU_TYPE'
export const MENU_STRUCTURE = 'MENU_STRUCTURE'
export const MENU = 'MENU'
export const MENU_LIST = 'MENU_LIST'
export const SECTION_LIST = 'SECTION_LIST'
export const DISH_LIST = 'DISH_LIST'
export const GLOBAL = 'GLOBAL'
export const SCRAPING_FLAG = 'SCRAPING_FLAG'

export const SCRAPING_TAG_TYPES = mapKeys(
  [
    { name: 'Custom', value: CUSTOM },
    { name: 'Menu type', value: MENU_TYPE },
    { name: 'Menu structure', value: MENU_STRUCTURE },
    { name: 'Menu', value: MENU },
    { name: 'Menu list', value: MENU_LIST },
    { name: 'Section list', value: SECTION_LIST },
    { name: 'Dish list', value: DISH_LIST },
    { name: 'Global', value: GLOBAL },
    { name: 'Flag', value: SCRAPING_FLAG },
  ],
  'value',
)
